export function isPromise<V>(
    mayBePromise: V | Promise<V>| void
): mayBePromise is Promise<V> {
    if (typeof mayBePromise == "object" && mayBePromise !== null) {
        if (
            hasOwnProperty(mayBePromise, "then") &&
            typeof mayBePromise.then === "function"
        ) {
            return true;
        }
    }

    return false;
}

function hasOwnProperty<X extends object, Y extends PropertyKey>(
    obj: X,
    prop: Y
): obj is X & Record<Y, unknown> {
    return Reflect.has(obj, prop);
}
